<script lang="ts">
import airbrake from '../../airbrake.js'
import Vue from 'vue'

export default Vue.extend({
  name: 'LoginCallback',
  computed: {
    hasError() {
      return !!(this.$route.query || {}).error
    },
    errorMessage() {
      return (this.$route.query || {}).error_description || 'Unknown Okta error'
    },
  },
  created() {
    if (this.hasError) {
      airbrake.notify({
        error: new Error('LoginCallback error'),
        context: { component: 'PWA' },
        params: {
          oktaError: this.errorMessage,
        },
      })
    }
  },
  methods: {
    async handleLoginRedirect() {
      await this.$auth.handleLoginRedirect()
    },
  },
})
</script>

<template lang="pug">
.container-fluid.d-flex.align-items-center.justify-content-center
  h3.mt-5.text-danger(v-if="hasError") Okta error: {{ errorMessage }}
  button.btn.btn-secondary.text-white.mt-5(v-else @click="handleLoginRedirect" type="button") Przejdź do Collectomate
</template>
